// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyCH2RKC54iXgEdv3Av2fhEUdhtw89IIlmI",
    authDomain: "ev-rem.firebaseapp.com",
    projectId: "ev-rem",
    storageBucket: "ev-rem.appspot.com",
    messagingSenderId: "613967552512",
    appId: "1:613967552512:web:3f8834c9a1cae9c1d878e5",
    measurementId: "G-HSC60BJD1N"
  },
  url:''
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
